import { useState } from "react";
import {
    Alert,
    Box,
    Button,
    Card,
    CardContent,
    CardHeader,
    Container,
    Divider,
    Grid,
    Stack,
    TextField,
    Typography
} from "@mui/material";
import SettingsIcon from "@mui/icons-material/Settings";
import { Layout } from "../layout/Layout";
import { GlobalDataShape, loadGlobalData, saveGlobalData } from "../../hooks/useGlobalData";
import DigitalSignature from "../clients/SignaturePad";

type CompanyDetails = GlobalDataShape["companyDetails"];

export const Settings = () => {
    const [data, setData] = useState<GlobalDataShape>(() => loadGlobalData());
    const [saved, setSaved] = useState(false);

    const companyDetails = data.companyDetails;

    const updateField = (key: keyof CompanyDetails, value: string) => {
        setSaved(false);
        setData((prev) => ({
            ...prev,
            companyDetails: {
                ...prev.companyDetails,
                [key]: value
            }
        }));
    };

    const onSave = () => {
        saveGlobalData(data);
        setSaved(true);
    };

    return (
        <Layout>
            <Box component="main" sx={{ flexGrow: 1, py: 8 }}>
                <Container maxWidth="lg">
                    <Stack spacing={3}>
                        <Card>
                            <CardHeader
                                avatar={<SettingsIcon />}
                                title="Rregullimet"
                                subheader="Menaxho të dhënat e kompanisë dhe nënshkrimin digjital"
                            />
                            <Divider />
                            <CardContent>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} md={6}>
                                        <TextField fullWidth label="Emri i kompanisë" value={companyDetails.name || ""} onChange={(e) => updateField("name", e.target.value)} />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <TextField fullWidth label="Email" value={companyDetails.email || ""} onChange={(e) => updateField("email", e.target.value)} />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <TextField fullWidth label="Telefoni" value={companyDetails.phone || ""} onChange={(e) => updateField("phone", e.target.value)} />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <TextField fullWidth label="Qyteti" value={companyDetails.city || ""} onChange={(e) => updateField("city", e.target.value)} />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField fullWidth label="Adresa" value={companyDetails.address || ""} onChange={(e) => updateField("address", e.target.value)} />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <TextField fullWidth label="Numri i llogarisë" value={companyDetails.accountNumber || ""} onChange={(e) => updateField("accountNumber", e.target.value)} />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <TextField fullWidth label="IBAN" value={companyDetails.iban || ""} onChange={(e) => updateField("iban", e.target.value)} />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <TextField fullWidth label="Kodi SWIFT" value={companyDetails.swiftCode || ""} onChange={(e) => updateField("swiftCode", e.target.value)} />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <TextField fullWidth label="Numri i biznesit" value={companyDetails.businessNumber || ""} onChange={(e) => updateField("businessNumber", e.target.value)} />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <TextField fullWidth label="Numri fiskal" value={companyDetails.taxNumber || ""} onChange={(e) => updateField("taxNumber", e.target.value)} />
                                    </Grid>
                                </Grid>
                            </CardContent>
                        </Card>

                        <Card>
                            <CardHeader title="Nënshkrimi digjital" />
                            <Divider />
                            <CardContent>
                                <Stack spacing={2}>
                                    <Typography variant="body2" color="text.secondary">
                                        Përdor të njëjtin pad të nënshkrimit si te format e klientëve.
                                    </Typography>
                                    <DigitalSignature
                                        onSave={(signature) => updateField("digitalSignature", signature || "")}
                                        initialSignature={companyDetails.digitalSignature || null}
                                    />
                                </Stack>
                            </CardContent>
                        </Card>

                        <Stack direction="row" spacing={2} justifyContent="flex-end">
                            <Button variant="contained" onClick={onSave} sx={{ textTransform: "none" }}>
                                Ruaj rregullimet
                            </Button>
                        </Stack>

                        {saved ? (
                            <Alert severity="success">Rregullimet u ruajtën me sukses.</Alert>
                        ) : null}
                    </Stack>
                </Container>
            </Box>
        </Layout>
    );
};

export default Settings;
